<script setup lang="ts">
import { Vue3Lottie } from 'vue3-lottie'

interface Props {
  src: string
  width?: number
  height?: number
  autoplay?: boolean
  loop?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  width: 100,
  height: 100,
  autoplay: true,
  loop: true,
})
</script>

<template>
  <div
    :style="{ width: `${width}px`, height: `${height}px` }"
    class="flex items-center justify-center"
  >
    <Vue3Lottie
      :animation-link="src"
      :width="width"
      :height="height"
      :autoplay="autoplay"
      :loop="loop"
    />
  </div>
</template>
